import React from 'react';
import './Services.css'
import { CgCheck } from 'react-icons/cg'
const Services = () => {
  return (
    <section id="services">
      <h5>What I offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>Database Design</h3>
          </div>
          <div className="service__list">
            <ul>
              <li>
                <CgCheck service__list-icon/>
                <p>
                Data modeling and normalization.</p>  
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Database design and architecture.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Performance optimization.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Data migration and integration.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Reporting and data analysis.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Scalability and capacity planning.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Database Development.</p>
              </li>
            </ul>
          </div>
        </article>
        
        <article className="service">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>
          <div className="service__list">
            <ul>
              <li>
                <CgCheck service__list-icon />
                <p>
                Website Development.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                E-commerce Development.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Web Application Development.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Content Management Systems(CMS).</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Responsive Web Design.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Website Optimization.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                API Development.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Web Hosting and Deployment.</p>
              </li>
            </ul>
          </div>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Android Development</h3>
          </div>
          <div className="service__list">
            <ul>
              <li>
                <CgCheck service__list-icon />
                <p>
                Android App Development.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                App Prototyping & wireframing.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                App perfomance optimization.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                App Maintenance.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                App Store Submission Assistance.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                App Integration and API Development.</p>
              </li>
              <li>
                <CgCheck service__list-icon />
                <p>
                Consulting and Advice.</p>
              </li>
            </ul>
          </div>
        </article>
      </div>
    </section>
  )
}

export default Services
